/**
 * On narrow layouts the filter sidebar stacks above the results, so after
 * changing a filter the user has to scroll down to see the effect. This
 * helper smoothly scrolls the results into view — desktop layouts (sidebar
 * next to results) are left untouched.
 */

/** Below this viewport width the sidebar stacks above the results (matches Home / Search CSS). */
export const STACKED_LAYOUT_MAX_WIDTH = 960;

/** Height of the sticky header (5rem) plus a little breathing room. */
const STICKY_NAV_OFFSET = 88;

/** True when filters sit above the results (mobile + tablet). */
export function isStackedFilterLayout(): boolean {
  return typeof window !== 'undefined' && window.innerWidth < STACKED_LAYOUT_MAX_WIDTH;
}

export function scrollToResultsIfStacked(target: HTMLElement | null): (() => void) | undefined {
  if (!target || !isStackedFilterLayout()) {
    return undefined;
  }
  // Small delay so the results section re-renders before we measure it.
  const timeout = window.setTimeout(() => {
    const top = target.getBoundingClientRect().top + window.scrollY - STICKY_NAV_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }, 80);
  return () => window.clearTimeout(timeout);
}
